// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"87686b8d","537":"958c59ff"}[chunkId] + ".chunk.js";
};